import React from "react";

// @material-ui/icons
import { CircularProgress } from '@mui/material';
import ComplexStatisticsCard from "components/Card/StatisticsCards/ComplexStatisticsCard";
import { Box } from '@mui/material';
import { Alert } from '@mui/material';

import { useQuery } from "react-query";
import { useToken } from "hooks/token.js";
import { useAxiosAuth } from "hooks/axios.js";

import axios from "axios";

export default function PodCard(props) {
  const url = "/api/v1/k8s/helms"
  const [token, setToken] = useToken();
  useAxiosAuth(token);

  const { isLoading, error, data } = useQuery(
    "helm", () => axios.get(
      url,
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    ).then(
      (res) => (res.hasOwnProperty('data') && res.data.hasOwnProperty('data'))? res.data.data : null
      
    )
  )

  const helmCount = (data) => {
    if (data) {
      let count = 0
      let buckets = {}

      if ("items" in data) {
        data.items.forEach((item) => {
          let key = item.name+item.namespace;
          buckets[key] = 1;
        })
      }

      return Object.keys(buckets).length;
    } else {
      return 0
    }
  }

  return (
    <React.Fragment>
      {error ?
        <Box sx={{ paddingBottom: "10px" }}>
          <Alert severity="error">
            "Error loading data"
          </Alert>
        </Box>
        : null
      }
      {isLoading && <CircularProgress size={24} style={{marginLeft: '8%', position: 'fixed', top: '20%',  zIndex: '10'}} />}
      <ComplexStatisticsCard
        color="dark"
        icon="Helm"
        title="K8S Helm Charts"
        count={helmCount(data)}
        percentage={{
          color: "success",
          amount: "",
          label: "",
          opacity : isLoading ? '0.7' : '1',
          link: ""
        }}
      />
    </React.Fragment>
  );
}
